import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  cancelCashout,
  getCashout,
  getTransactions,
  paidCashout,
  getTransactionsStat,
} from '../api';

// export const useGetTransactions = () => {
//   return useQuery({
//     queryKey: ['transactions'],
//     queryFn: getTransactions,
//     //refetchOnWindowFocus: 'always',
//     staleTime: 30 * 60 * 1000,
//     cacheTime: 30 * 60 * 1000,
//     select: (data) => {
//       return data.data.resource;
//     },
//   });
// };

export const useGetTransactions = (filters?: {
  type?: string;
  status?: string;
  user?: string;
}) => {
  return useQuery({
    queryKey: ['transactions', filters], // queryKey changes when filters change
    queryFn: () => getTransactions(filters),
    staleTime: 30 * 60 * 1000,
    cacheTime: 30 * 60 * 1000,
    select: (data) => data.data.resource,
    keepPreviousData: true, // keeps old data while fetching new
  });
};

export const useGetTransactionsStats = () => {
  return useQuery({
    queryKey: ['TransactionsStat'],
    queryFn: getTransactionsStat,
    //refetchOnWindowFocus: 'always',
    staleTime: 30 * 60 * 1000,
    cacheTime: 30 * 60 * 1000,
    select: (data) => {
      return data.data.resource;
    },
  });
};

export const useGetCashout = (filters?: {
  pageSize?: number;
  startDate?: string;
  endDate?: string;
}) => {
  return useQuery({
    queryKey: ['cashouts', filters],
    queryFn: () => getCashout(filters),
    staleTime: 30 * 60 * 1000,
    cacheTime: 30 * 60 * 1000,
    keepPreviousData: true,
    select: (data) => {
      return data.data.resource;
    },
  });
};

export const usePaidCashout = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: paidCashout,
    onSuccess: () => {
      // Was a hardcoded setQueryData(['cashouts'], ...) splice — that only
      // ever matched the no-filter query key. Now that the cashout list is
      // keyed by its filters (['cashouts', filters]) for pagination/date
      // range, a plain refetch of every 'cashouts' query (any filter combo)
      // is the reliable way to reflect the change everywhere it's shown.
      queryClient.invalidateQueries({ queryKey: ['cashouts'] });
    },
    onError: (error) => {
      console.log({ error });
    },
  });
};

export const useCancelCashout = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: cancelCashout,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['cashouts'] });
    },
    onError: (error) => {
      console.log({ error });
    },
  });
};
